import ProductSearchResultsHtml from '../../app-lite/products/templates/product.search.results.html';

export function TireconnectSettingsCtrl (
  $state,
  $scope,
  $translate,
  integrations,
  messages,
  TireconnectSettings,
  workshopAPI
) {
  $scope.loaded       = true;

  $scope.TireconnectSettings = new TireconnectSettings(integrations);

  $scope.save = function (form) {
    $scope.TireconnectSettings.save().then(() => {
      messages.show($translate.instant('TIRECONNECT_SPACE.TIRECONNECT_SETTINGS_SAVED'), 'success');

      $state.reload();
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.saveLabor = function (form) {
    $scope.TireconnectSettings.saveLabor().then(() => {
      messages.show($translate.instant('TIRECONNECT_SPACE.TIRECONNECT_SETTINGS_SAVED'), 'success');

      $state.reload();
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.activate = function () {
    $scope.TireconnectSettings.activate().then(() => {
      messages.show($translate.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', { name: $scope.TireconnectSettings.name }), 'success');

      $state.reload();
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.remove = function () {
    $scope.TireconnectSettings.remove().then(() => {
      messages.show($translate.instant('JS_SPACE.INTEGRATIONS.REMOVED', { name: $scope.TireconnectSettings.name }), 'success');

      $state.reload();
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.productSearch = {
    format: function (product, key) {
      return angular.isObject(product) ? product.item_code: product;
    },
    query: function (value) {
      return workshopAPI.get('/products/product_labor_list', [ value, 0, 5 ]);
    },
    select: function (product, key) {
      $scope.TireconnectSettings.handleProductSelect(product, key);
    },
    templateUrl: ProductSearchResultsHtml
  };
}